import { Component, OnInit } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { PrestamosService } from '../../services/prestamos.service';
import { RutasService } from '../../services/rutas.service';
import { EmpleadosServicio } from '../../services/empleado.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Helper } from '../../helpers/helper';
import { CurrencyPipe, LowerCasePipe, DatePipe } from '@angular/common';
import { AlertasModales } from '../../helpers/alertasModales';
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { ClientesService } from '../../services/Clientes.service';

const ID_PAGINA = 8;

@Component({
  selector: 'app-presolicitudes',
  templateUrl: './presolicitudes.component.html',
  styleUrls: ['./presolicitudes.component.css']
})
export class PresolicitudesComponent implements OnInit {
  listaPrestamos: Array<any>;
  titulo = 'Solicitudes de Préstamos';
  filtro: number;
  mostrar = '';
  loaded = false;
  loading = false;
  estado = -1;
  fecha_desde: NgbDateStruct;
  fecha_hasta: NgbDateStruct;
  now = new Date(this.helper.getDate());
  page = 1;
  limit = '50';
  offset = 0;
  size = 0;
  rutas = [];
  multiSelectPrestamos: any;
  rutasSeleccionadas = [];
  rutasSeleccionadasAntes = false;
  registroSolicitud = '0';
  nc = '';
  empleado: any;
  exportando = false;
  configPdf;
  total_prestado: number;
  form: FormGroup;
  active = 0;
  columnsSort = [];
  private columnsServer = [];
  constructor(private prestamoService: PrestamosService,
    private rutaService: RutasService,
    private empleadoService: EmpleadosServicio,
    private route: ActivatedRoute,
    private helper: Helper,
    private router: Router,
    private clientesService: ClientesService,
    private modals: AlertasModales) {
    if (empleadoService.datosEmpleado.tipo_empleado !== 3 && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == ID_PAGINA).length) {
      this.router.navigate(['/404']);
    }

    this.initRutas();
    this.initConfigPdf();
    this.initForm();
    this.initColumns();
    /*if ( localStorage.getItem('rutasSeleccionadas')) {
      this.rutasSeleccionadas = JSON.parse(localStorage.getItem('rutasSeleccionadas'));
    }*/
    this.rutasSeleccionadas = rutaService.getSelectedRoutes();
    if (this.rutasSeleccionadas.length > 0) {
      this.rutasSeleccionadasAntes = true;
    }
    this.empleado = this.empleadoService.datosEmpleado;
  }

  ngOnInit() {
    this.initConfigMultiSelect();
    this.verificarQueryString();
  }

  private cargarPresolicitudes(): void {
    this.loading = true;
    let fecha_desde = '';
    let fecha_hasta = '';
    if (this.fecha_desde) {
      fecha_desde = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (this.fecha_hasta) {
      fecha_hasta = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }

    // tslint:disable-next-line:max-line-length
    this.prestamoService.obtenerListaPresolicitudesPrestamos(
      this.estado,
      fecha_desde,
      fecha_hasta,
      this.rutasSeleccionadas.map(data => data.id).join(),
      this.limit,
      this.offset,
      this.nc,
      this.active,
      JSON.stringify(this.columnsServer),
      this.registroSolicitud)
    .subscribe(res => {
      this.listaPrestamos = res.prestamos;
      if (this.active && res.prestamos.length) {
        if (
          res.prestamos[0].estado === 0 &&
          res.prestamos[0].ID_EMPLEADO_VERIFICANDO &&
          res.prestamos[0].ID_EMPLEADO_VERIFICANDO !== this.empleadoService.datosEmpleado.ID_EMPLEADO) {
            this.modals.validacionesModalJquery('Advertencia',
            `Esta pre-solicitud ya está siendo verificada por <b>${res.prestamos[0].empleado_verificando}</b>`,
            'orange',
            'modern',
            false,
            'fa fa-bullhorn');
        }
      }
      (<FormArray>this.form.get('array')).controls = [];
      for (const row of res.prestamos) {
        (<FormArray>this.form.get('array')).push(
          new FormGroup({
            ID: new FormControl(row.ID),
            cliente: new FormControl({ value: row.cliente, disabled: true }),
            identificacion: new FormControl({ value: row.identificacion, disabled: true }),
            telefono: new FormControl({ value: row.telefono, disabled: true }),
            capital: new FormControl(row.monto, [Validators.required, Validators.min(1)]),
            empleado: new FormControl({ value: row.empleado, disabled: true }),
            ID_RUTA: new FormControl(row.ID_RUTA),
            ID_EMPLEADO: new FormControl(row.ID_EMPLEADO),
            ruta: new FormControl({ value: row.ruta, disabled: true }),
            fecha_registro: new FormControl({ value: row.fecha_registro, disabled: true }),
            foto: new FormControl({ value: row.foto, disabled: true }),
            estado: new FormControl({ value: row.estado, disabled: true }),
            en_oficina: new FormControl({ value: row.en_oficina, disabled: true }),
            asignado_a: new FormControl({ value: row.asignado_a, disabled: true }),
          })
        );
      }
      this.size = res.total_items;
      this.total_prestado = res.total_prestado;
      setTimeout(() => {
        this.loaded = true;
        this.loading = false;
      }, 1);
    });
  }

  private initConfigMultiSelect() {
    this.multiSelectPrestamos = {
      singleSelection: false,
      text: 'Seleccionar zona',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit: 3,
      searchPlaceholderText: 'Búsqueda',
      disabled: this.registroSolicitud == '1'
    };
  }

  private initRutas(): void {
    this.rutaService.cargarTodasLasRutas()
    .subscribe(res => {
      for (const ruta of res.rutas) {
        this.rutas.push({
          id: ruta.ID_RUTA,
          itemName: String(ruta.nombre)
        });
      }
    });
  }

  filtrarPresolicitudes() {
    this.initConfigMultiSelect();
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);

    queryParams['nc'] = this.nc;
    switch (this.estado) {
      case 0:
        queryParams['estado'] = 'pendientes';
        this.titulo = 'Pre-solicitudes de Préstamos pendientes';
        break;
        case 1:
        queryParams['estado'] = 'aprobadas';
        this.titulo = 'Pre-solicitudes de Préstamos aprobadas';
        break;
        case 2:
        queryParams['estado'] = 'denegadas';
        this.titulo = 'Pre-solicitudes de Préstamos denegadas';
        break;
      default:
      queryParams['estado'] = 'todos';
        this.titulo = 'Pre-solicitudes de Préstamos';
      break;
    }

    switch (parseFloat(this.registroSolicitud)) {
      case 1:
        this.rutasSeleccionadas = [];
        queryParams['solicitud'] = 'oficina';
      break;
      case 2:
        queryParams['solicitud'] = 'movil';
      break;
      default:
        queryParams['solicitud'] = 'todas';
      break;
    }

    if (this.fecha_desde) {
      queryParams['fecha_inicia'] = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (this.fecha_hasta) {
      queryParams['fecha_termina'] = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }
    const rutas = this.rutasSeleccionadas.map(data => data.id).join();
    if (rutas) {
      queryParams['rutas'] = rutas;
    } else {
      delete queryParams['rutas'];
    }
    queryParams['limite'] = this.limit;

    this.router.navigate(['./lista/pre-solicitudes-prestamos'], { queryParams: queryParams });
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {

        if (params.rutas) {
          this.rutasSeleccionadas = [];
          for (const ruta of this.rutas) {
            for (const rutaSeleccionada of params.rutas.split(',')) {
              if (parseFloat(rutaSeleccionada) === ruta.id) {
                this.rutasSeleccionadas.push(ruta);
              }
            }
          }
          if (this.rutas.length > 0) {
            this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          }
        }
        if  (this.rutasSeleccionadas.length > 0)  {

          this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          this.rutasSeleccionadasAntes = false;
        } else {
          if  (this.rutasSeleccionadasAntes) {
            this.rutasSeleccionadas = this.rutaService.getSelectedRoutes();
            this.rutasSeleccionadasAntes = false;
          } else  {
            this.rutaService.removeSelectedRoutes();
          }

        }
        if (params.page && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = parseFloat(this.limit) * (this.page - 1);
        }
        if (params.nc) {
          this.nc = params.nc;
        }
        if (!isNaN(params.limite)) {
          this.limit = params.limite;
        }
        if (params.fecha_inicia || params.fecha_termina) {

          if (params.fecha_inicia) {
            const yearInit = parseFloat(params.fecha_inicia.split('-')[0]);
            const monthInit = parseFloat(params.fecha_inicia.split('-')[1]);
            const dayInit = parseFloat(params.fecha_inicia.split('-')[2]);

            if ( !isNaN( yearInit ) && !isNaN( monthInit ) && !isNaN( dayInit ) ) {
              this.fecha_desde = { year: yearInit, month: monthInit, day: dayInit };
            }
          }

          if (params.fecha_termina) {
            const yearEnd = parseFloat(params.fecha_termina.split('-')[0]);
            const monthEnd = parseFloat(params.fecha_termina.split('-')[1]);
            const dayEnd = parseFloat(params.fecha_termina.split('-')[2]);

            if ( !isNaN( yearEnd ) && !isNaN( monthEnd ) && !isNaN( dayEnd ) ) {
              this.fecha_hasta = { year: yearEnd, month: monthEnd, day: dayEnd };
            }
          }
        } else if (params.fecha) {
          const yearInit = parseFloat(params.fecha.split('-')[0]);
          const monthInit = parseFloat(params.fecha.split('-')[1]);
          const dayInit = parseFloat(params.fecha.split('-')[2]);

          const yearEnd = parseFloat(params.fecha.split('-')[0]);
          const monthEnd = parseFloat(params.fecha.split('-')[1]);
          const dayEnd = parseFloat(params.fecha.split('-')[2]);
          if ( (!isNaN( yearInit ) && !isNaN( monthInit ) && !isNaN( dayInit )) &&
              (!isNaN( yearEnd ) && !isNaN( monthEnd ) && !isNaN( dayEnd )) ) {
            this.fecha_desde = { year: yearInit, month: monthInit, day: dayInit };
            this.fecha_hasta = { year: yearEnd, month: monthEnd, day: dayEnd };
          }
        }

        if (params.estado) {
          switch (params.estado) {
            case 'pendientes':
              this.estado = 0;
              this.titulo = 'Pre-solicitudes de Préstamos pendientes';
            break;
            case 'aprobadas':
              this.estado = 1;
              this.titulo = 'Pre-solicitudes de Préstamos aprobadas';
            break;
            case 'denegadas':
              this.estado = 2;
              this.titulo = 'Pre-solicitudes de Préstamos denegadas';
            break;
            default:
              this.estado = -1;
              this.titulo = 'Pre-solicitudes de Préstamos';
            break;
          }
        }

        if (params.solicitud) {
          switch (params.solicitud) {
            case 'oficina':
              this.registroSolicitud = '1';
            break;
            case 'movil':
              this.registroSolicitud = '2';
            break;
            default:
              this.registroSolicitud = '0'
            break;
          }
        }

        if (params.pre) {
          this.active = params.pre;
        } else {
          this.active = 0;
        }
        this.columnsServer = [];
        // tslint:disable-next-line:forin
        for (const columnParams in params) {
          for (const column of this.columnsSort) {
            if (column.label.replace(/\s/g, '').toLowerCase() === columnParams.replace('order', '')) {
              if (params[columnParams].toLowerCase() === 'asc' || params[columnParams].toLowerCase() === 'desc') {
                column.order = params[columnParams].toLowerCase();
                this.columnsServer.push(column);
                break;
              }
            }
          }
        }
        this.cargarPresolicitudes();
      }
    });
  }

  loadPage(page: number) {
    this.page = page;
    this.offset = parseFloat(this.limit) * (this.page - 1);
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['page'] = page;
    this.router.navigate(['./lista/pre-solicitudes-prestamos'], { queryParams: queryParams });
  }

  private initConfigPdf(): void {
    this.prestamoService.obtenerConfiguracionPrestamo()
    .subscribe((res: any) => {
      this.configPdf = {
        direccion: res.direccion_recibo,
        tel: res.telefono_recibo,
        nombre_compania: res.descripcion,
        rnc_compania: res.rnc,
        fax_compania: res.fax,
        email_compania: res.email,
        ciudad_compania: res.ciudad,
        tel_compania: res.telefono,
        direccion_compania: res.direccion
      };
    });
  }

  exportar() {
    if (this.empleadoService.permisosAsignados.filter(a => a.ID_PERMISO == 1).length || this.empleadoService.datosEmpleado.tipo_empleado === 3) {

      if (!this.exportando && this.listaPrestamos.length > 0) {
        this.exportando = true;
        const title = `${this.titulo}${this.mostrar}`;
        const rows = [];
        const currencyPipe = new CurrencyPipe('en-US');
        const lowerCasePipe = new LowerCasePipe();
        const datePipe = new DatePipe('en-US');

        const columns = [
          {title: 'Cliente', dataKey: 0},
          {title: 'Identificación', dataKey: 1},
          {title: 'Teléfono', dataKey: 2},
          {title: 'Capital', dataKey: 3},
          {title: 'Empleado', dataKey: 4},
          {title: 'Ruta', dataKey: 5},
          {title: 'Fecha registro', dataKey: 6},
          {title: 'Estado', dataKey: 7},
        ];

        let fecha_desde = '';
        let fecha_hasta = '';
        if (this.fecha_desde !== undefined && this.fecha_desde !== null && this.fecha_desde.year !== null) {
          fecha_desde = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
        }

        if (this.fecha_hasta !== undefined && this.fecha_hasta !== null && this.fecha_hasta.year !== null) {
          fecha_hasta = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
        }
        // tslint:disable-next-line:max-line-length
        this.prestamoService.obtenerListaPresolicitudesPrestamos(this.estado, fecha_desde, fecha_hasta, this.rutasSeleccionadas.map(data => data.id).join(), 0, 0, this.nc, null, JSON.stringify(this.columnsServer), this.registroSolicitud)
        .subscribe(res => {

          for (const row of res.prestamos) {
            rows.push({
              0: this.helper.capitalizeFirstLetter( lowerCasePipe.transform(row.cliente) ),
              1: row.identificacion,
              2: row.telefono,
              3: currencyPipe.transform(row.monto),
              4: this.helper.capitalizeFirstLetter( lowerCasePipe.transform(row.empleado) ),
              5: lowerCasePipe.transform(row.ruta),
              6: datePipe.transform(row.fecha_registro, 'dd-MM-yyyy'),
              7: `${row.estado === 1 ? 'Aprobado' : row.estado === 2 ? 'Denegado' : 'Pendiente'}`
            });
          }

          // Add footer
          rows.push({
            0: `Total: ${rows.length}`,
            3: currencyPipe.transform(this.total_prestado),
          });

          const columnStyles = {
            1: {columnWidth: 80},
            2: {columnWidth: 80},
            6: {columnWidth: 80},
            7: {columnWidth: 50},
          };

          this.helper.exportarReportePdf(this.configPdf, title, columns, rows, this.empleado.nombreCompleto, columnStyles)
          .then(() => {
            this.exportando = false;
          })
          .catch(() => {
            this.exportando = false;
          });
        });
      }
    } else {
      this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
      'red',
      'modern',
      false,
      'fa fa-thumbs-down');
    }
  }

  aprobar(presolicitud: FormGroup) {
    if (presolicitud.get('ruta').value && presolicitud.get('empleado').value) {
      // tslint:disable-next-line:max-line-length
      const msg = `Aprobar pre-solicitud de préstamo del cliente <b>${presolicitud.get('cliente').value}</b> de <b>${presolicitud.get('capital').value}</b> de la ruta <b>${presolicitud.get('ruta').value}</b>`;
      this.modals.confirmModalJquery('¿Estas seguro?', msg, 'orange', 'material')
      .then(res => {
        if (res === 'SI') {
          this.clienteExiste(presolicitud.get('identificacion').value, 'No puedes continuar con la aprobación')
          .then(() => {
            const data = {
              ID: presolicitud.get('ID').value,
              estado: 1
            };
            this.prestamoService.actualizarEstadoPresolicitud(data)
            .subscribe(x => {
              if (x) {
                presolicitud.get('estado').setValue(1);
              }
            });
          });
        }
      });
    }
  }

  denegar(presolicitud: FormGroup) {
    // tslint:disable-next-line:max-line-length
    const msg = `Denegar pre-solicitud de préstamo del cliente <b>${presolicitud.get('cliente').value}</b> de <b>${presolicitud.get('capital').value}</b> de la ruta <b>${presolicitud.get('ruta').value}</b>`;
    this.modals.promptNgbModal('¿Estas seguro?', msg)
    .then(res => {
      if (res.continue) {
        this.clienteExiste(presolicitud.get('identificacion').value, 'No puedes continuar con la denegación')
        .then(() => {
          const data = {
            ID: presolicitud.get('ID').value,
            estado: 2,
            razon_denegacion: res.content
          };
          this.prestamoService.actualizarEstadoPresolicitud(data)
            .subscribe(x => {
              if (x) {
                presolicitud.get('estado').setValue(2);
              }
            });
        });
      }
    });
  }

  verSolicitud(presolicitud: FormGroup) {
    this.modals.detalleSolicitudNgbModal(presolicitud.get('ID').value);
  }

  private initForm() {
    this.form = new FormGroup({
      array: new FormArray([])
    });
  }

  editar(presolicitud: FormGroup) {
    if (presolicitud.valid) {
      // tslint:disable-next-line:max-line-length
      const msg = `Editar el capital de la pre-solicitud de préstamo del cliente <b>${presolicitud.get('cliente').value}</b> de la ruta <b>${presolicitud.get('ruta').value}</b>`;
      this.modals.confirmModalJquery('¿Estas seguro?', msg, 'orange', 'material')
      .then(res => {
        if (res === 'SI') {
          this.clienteExiste(presolicitud.get('identificacion').value, 'No puedes continuar con la edición')
          .then(() => {
            const data = {
              ID: presolicitud.get('ID').value,
              capital: presolicitud.get('capital').value
            };
            this.prestamoService.actualizarCapitalPresolicitud(data)
              .subscribe();
          });
        }
      });
    }
  }

  private clienteExiste(identificacion: string, titleModal = 'No puedes continuar'): Promise<any> {
    return new Promise((resolve, reject) => {
      this.clientesService.clienteExiste(identificacion)
        .subscribe(
          (res: any) => {
            if (res) {
              const datePipe = new DatePipe('en-US');
              // tslint:disable-next-line:max-line-length
              const msg = `El cliente <b>${this.helper.capitalizeFirstLetter(new LowerCasePipe().transform(res.cliente))}</b> portador de la cédula/pasaporte <b>${res.cedula}</b> registrado por <b>${this.helper.capitalizeFirstLetter(new LowerCasePipe().transform(res.empleado))}</b> el <b>${datePipe.transform(res.fecha_registro, 'dd')} ${this.helper.monthNames[datePipe.transform(res.fecha_registro, 'M')]}, ${datePipe.transform(res.fecha_registro, 'y')}</b> a las <b>${datePipe.transform(res.fecha_registro, 'h:mm a')}</b>, ya existe.
              `;
              this.modals.validacionesModalJquery(titleModal, msg, 'red', 'material');
            } else {
              resolve('No existe, puedes continuar.');
            }
          },
          err => {
            if (err) {
              reject('No se pudo realizar la operación, por razones desconocidas');
            }
          });
    });
  }

  orderTable(column) {
    if (!column.order) {
      column.order = 'desc';
    } else {
      column.order = column.order === 'desc' ? 'asc' : 'desc';
    }
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    delete queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`];
    queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`] = column.order;
    this.router.navigate(['./lista/pre-solicitudes-prestamos'], { queryParams: queryParams });
  }


  private initColumns(): void {
    this.columnsSort = [
      {
        label: 'Cliente',
        column: 'cliente',
        order: ''
      },
      {
        label: 'Identificación',
        column: 'p.identificacion',
        order: ''
      },
      {
        label: 'Teléfono',
        column: 'p.telefono',
        order: ''
      },
      {
        label: 'Capital',
        column: 'p.monto',
        order: ''
      },
      {
        label: 'Empleado',
        column: 'empleado',
        order: ''
      },
      {
        label: 'Zona',
        column: 'ruta',
        order: ''
      },
      {
        label: 'Fecha Registro',
        column: 'p.fecha_registro',
        order: ''
      },
      {
        label: 'Estado',
        column: 'p.estado',
        order: ''
      },
    ];
  }

  asignarCobrador(item, index: number) {
    this.modals.seleccionarEmpleadoNgbModal(2, item.ID_RUTA, item.ID_EMPLEADO)
    .then(value => {
      if (value) {
        const data = {
          ID_SOLICITUD: item.ID,
          ID_EMPLEADO: value.ID_EMPLEADO
        };
        this.empleadoService.asignarSolicitud(data)
        .subscribe(() => {
          (this.form.get('array') as FormArray)
          .controls[index].get('ID_EMPLEADO').setValue(data.ID_EMPLEADO);

          this.modals.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-sun-ofa fa-plus');
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/presolicitudes/presolicitudes.component.ts